import { render, staticRenderFns } from "./RegisterRevenue.vue?vue&type=template&id=ffe7a3fa&scoped=true"
import script from "./RegisterRevenue.vue?vue&type=script&lang=js"
export * from "./RegisterRevenue.vue?vue&type=script&lang=js"
import style0 from "./RegisterRevenue.vue?vue&type=style&index=0&id=ffe7a3fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe7a3fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffe7a3fa')) {
      api.createRecord('ffe7a3fa', component.options)
    } else {
      api.reload('ffe7a3fa', component.options)
    }
    module.hot.accept("./RegisterRevenue.vue?vue&type=template&id=ffe7a3fa&scoped=true", function () {
      api.rerender('ffe7a3fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/TuitionManagement/RegisterRevenue.vue"
export default component.exports